<template>
  <div>
    <a-menu  mode="horizontal" v-model:selectedKeys="tabCode" @click="SwitchLang">
      <a-menu-item v-for="(item) in tabList" :key="item.code" style="top:0px; line-height: 55px; padding-left: 10px; padding-right: 10px;margin-right: 40PX;">
        {{ item.name }}
      </a-menu-item>
    </a-menu>

    <div v-if="queryParam.userType == 1">
      <a-card :bordered="false" :bodyStyle="tstyle">
        <div class="table-page-search-wrapper" v-if="hasPerm('recipe:page')">
          <a-form layout="inline">
            <a-row :gutter="48">
                <a-col :md="6" :sm="24">
                  <a-form-item label="排序方式">
                    <a-radio-group  buttonStyle="solid"  v-model="queryParam.orderField">
                      <a-radio value="0">积分</a-radio>
                      <a-radio value="1">交易金额</a-radio>
                    </a-radio-group>
                  </a-form-item>
                </a-col>

                <a-col :md="8" :sm="24">
                  <a-form-item label="患者姓名/ID">
                    <a-input v-model="queryParam.userIdOrName" allow-clear placeholder="请输入患者姓名/ID" />
                  </a-form-item>
                </a-col>
                <!-- 无法清空多选状态 -->
                <!-- <a-col :md="8" :sm="24">
                  <a-form-item label="反选">
                    <a-button type="primary" :disabled="!hasSelected" :loading="loading" @click="start">
                      Reload
                    </a-button>
                    <a-switch v-model:checked="options.rowSelection.checkStrictly"></a-switch>
                  </a-form-item>
                </a-col> -->
           
                <!-- <a-col :md="8" :sm="24">
                  <a-form-item label="积分类型">
                    <a-input v-model="queryParam.status" allow-clear placeholder="请输入状态"/>
                    <a-select v-model="queryParam.status" allow-clear placeholder="请选择积分类型" :options="recipeStatus"></a-select>
                  </a-form-item>
                </a-col> -->
              <a-col :md="8" :sm="24" >
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                  <a-button type="primary" style="margin-left: 8px" @click="batchSend()">批量创建获奖名单</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </a-card>
      <a-card :bordered="false">
        <s-table
          ref="table"
          :columns="columns"
          :data="loadData"
          :alert="options.alert"
          :rowKey="(record) => record.id"
          :rowSelection="options.rowSelection"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="$refs.addFormSingle.add(record,queryParam.userType)">填写获奖内容</a>
          </span>
        </s-table>
        
      </a-card>
   </div>
   <div v-else>
      <a-card :bordered="false" :bodyStyle="tstyle">
        <div class="table-page-search-wrapper" v-if="hasPerm('recipe:page')">
          <a-form layout="inline">
            <a-row :gutter="48">
                <a-col :md="8" :sm="24">
                  <a-form-item label="医生姓名/ID">
                    <a-input v-model="queryParam.userIdOrName" allow-clear placeholder="请输入医生姓名/ID" />
                  </a-form-item>
                </a-col>
              
              <a-col :md="8" :sm="24" >
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                  <a-button type="primary" style="margin-left: 8px" @click="batchSend()">批量创建获奖名单</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </a-card>
      <a-card :bordered="false">
        <s-table
          ref="table"
          :columns="doctorColumns"
          :data="loadData"
          :alert="options.alert"
          :rowKey="(record) => record.id"
          :rowSelection="options.rowSelection"
        >

          <span slot="action" slot-scope="text, record">
            <a @click="$refs.addFormSingle.add(record,queryParam.userType)">填写获奖内容</a>
          </span>
        </s-table>
        
      </a-card>
   </div>


    <add-form-single ref="addFormSingle" @ok="handleOk" />
    <add-form-batch ref="addFormBatch" @ok="handleOk" />
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { baUserPointsPage } from '@/api/modular/interhospital/integral/integralManage'
  import addFormSingle from './addForm.vue'
  import addFormBatch from './addFormBatch.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      editForm,
      addFormSingle,
      addFormBatch,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          userType:1,
          userIdOrName:'',
          orderField:'0'
        },
        tabCode:['1'],
        // // 状态
        // recipeStatus : [
        //   {
        //     value: '',
        //     label: '全部',
        //   },
        //   {
        //     value: '1',
        //     label: '就诊人积分',
        //   },
        //   {
        //     value: '2',
        //     label: '医生积分',
        //   },
        // ],
        
        // 表头
        columns: [
          {
            title: '序号',
            align: 'center',
            dataIndex: 'id'
          },
          {
            title: '患者ID',
            align: 'center',
            dataIndex: 'userId'
          },
          {
            title: '患者姓名',
            align: 'center',
            dataIndex: 'userName',
          },
          {
            title: '手机号',
            align: 'center',
            dataIndex: 'mobile',
          },
          {
            title: '积分',
            align: 'center',
            dataIndex: 'points'
          },
          {
            title: '总交易金额（元）',
            align: 'center',
            dataIndex: 'totalAmount',
          }
        ],
        doctorColumns:[
          {
            title: '序号',
            align: 'center',
            dataIndex: 'id'
          },
          {
            title: '医生ID',
            align: 'center',
            dataIndex: 'userId'
          },
          {
            title: '医生姓名',
            align: 'center',
            dataIndex: 'userName',
          },
          {
            title: '科室',
            align: 'center',
            dataIndex: 'deptName',
          },
          {
            title: '职称',
            align: 'center',
            dataIndex: 'protitle',
          },
          {
            title: '积分',
            align: 'center',
            dataIndex: 'points',
            sorter: (a, b) => a.points - b.points,
            scopedSlots: { customRender: 'points' }
          }
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('parameter',parameter,Object.assign(parameter,this.switchingDate()))
          return baUserPointsPage(Object.assign(parameter, this.switchingDate())).then((res) => {
            res.data.rows.map((item,index)=>{
              item['id'] = index+1
            })
            return res.data
          })
          // return []
        },
        selectedRowKeys: '',
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            checkStrictly:false,
            preserveSelectedRowKeys:true,
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange,
          }
        },
        tabList:[
          {code: "1", name: "就诊人积分", active: true},
          {code: "2", name: "医生积分", active: false},
        ],
        loading: false,
      }
    },
    created () {
      if (this.hasPerm('recipe:edit') || this.hasPerm('recipe:delete')) {
        console.log('this.hasPerm',this.hasPerm('recipe:edit') , this.hasPerm('recipe:delete'))
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
        this.doctorColumns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    computed: {
      hasSelected () {
        return this.selectedRowKeys.length > 0
      }
    },
    methods: {
      moment,
      SwitchLang(e){
        this.tabCode = e.keyPath;
        this.queryParam.userType = Number(e.key) 
        this.queryParam.userIdOrName = '';
        if(this.selectedRowKeys != ''){
          this.selectedRowKeys = []
          this.selectedRows = []
        }
      
        if(this.queryParam.userType == 2){
          console.log('SwitchLang22222',this.queryParam.userType)
          this.queryParam.orderField == "0";
        
        }
        this.$refs.table.refresh();
      },
      batchSend(){
        console.log('batchSend',this.queryParam.userType,this.selectedRowKeys)
        if(this.selectedRows.length>0){
          this.$refs.addFormBatch.add(this.selectedRows,this.queryParam.userType)
        }else if(this.selectedRowKeys == []){
          this.$message.warning('请勾选获奖人员')
        }else{
          this.$message.warning('请重新勾选获奖人员')
        }
      
      },
      /**
       * 查询参数组装
       */
      switchingDate () {
        console.log('tabCode',this.tabCode)
        const queryParamctstamp = this.queryParam.ctstampDate
        if (queryParamctstamp != null) {
            this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
            if (queryParamctstamp.length < 1) {
                delete this.queryParam.ctstamp
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },

      // 时间框赋值
      onChangectstamp(date, dateString) {
        this.queryParam.createTime = dateString
      },
   
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        // console.log('onSelectChange',selectedRowKeys, selectedRows)
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      start(){
      this.loading = true;
      // ajax request after empty completing
      setTimeout(() => {
        this.loading = false;
        this.selectedRowKeys = [];
      }, 1000);
    }
      
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
  .ant-menu-horizontal{
    border-bottom: none;
    padding-left: 24px;
    padding-right: 24px;
  }
  .ant-radio-checked .ant-radio-inner{
    border-color: #666;

  }
  .ant-radio-inner::after{
    background-color: #666;
  }
</style>
